import { createCatalogApplication } from "@/views/catalog/api";

// «Оформить онлайн» по позиции каталога — тот же поток, что в каталоге
// (Catalog.vue / Item.vue): сервер считает расчёт по позиции и создаёт лизинг,
// затем переходим на созданную заявку в этой же вкладке.
// Возвращает текст ошибки либо null, если переход выполнен.
const applyCatalogItem = async (item, router) => {
  try {
    const response = await createCatalogApplication(item);
    if (response && response.status && response.leasingId) {
      router.push({
        name: "leasings.leasing.item",
        params: { id: response.leasingId },
      });
      return null;
    }
    return (
      (response && response.error) ||
      "Не удалось оформить заявку. Попробуйте позже."
    );
  } catch (e) {
    return "Не удалось оформить заявку. Попробуйте позже.";
  }
};

// сумма в рублях без копеек для крупных значений: «27 381 000 ₽»
const rub = (value) => {
  const num = Number(value);
  if (!num) return "0 ₽";
  return Math.round(num).toLocaleString("ru-RU") + " ₽";
};

// сумма с копейками для сводки по договорам и штрафам: «90 039 613,00 ₽»
const money = (value) => {
  const num = Number(String(value ?? "").replace(",", "."));
  return (
    (isNaN(num) ? 0 : num).toLocaleString("ru-RU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + " ₽"
  );
};

// цена позиции каталога: «7 950 000 ₽» либо «Цена по запросу» (как в каталоге)
const priceMask = (value) => {
  return value ? Number(value).toLocaleString("ru-RU") + " ₽" : "Цена по запросу";
};

// краткие характеристики карточки из полей каталога: марка · модель · модификация
const itemSpecs = (item) => {
  return [item.brand, item.model, item.modification]
    .filter((part) => part)
    .join(" · ");
};

export { applyCatalogItem, rub, money, priceMask, itemSpecs };
